import { Dimensions, StyleSheet } from "react-native";
import { block } from "react-native-reanimated";

const styles = StyleSheet.create({
  safeAreaContainer: {
    flex: 1,
    backgroundColor: "#f0e5d8",
  },
  scrollViewContainer: {
    alignItems: "center",
  },
  title: {
    color: "#75cfb8",
    fontSize: 28,
    marginTop: 20,
  },
  emojiImageContainer: {
    margin: 5,
    shadowColor: "gray",
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.6,
    shadowRadius: 2,
    borderRadius: 10,
  },
  emojiImage: {
    width: 100,
    height: 100,
    borderRadius: 10,
  },
  selectedEmoji: {
    borderWidth: 3,
    borderColor: "#75cfb8",
  },
  emojiList: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
  },
  subtitle: {
    color: "#75cfb8",
    fontSize: 24,
    marginBottom: 5,
    marginTop: 20,
    marginLeft: "10%",
    marginRight: "10%",
  },
  messageInput: {
    fontSize: 18,
    width: "80%",
    borderColor: "white",
    borderRadius: 5,
    borderWidth: 10,
    backgroundColor: "white",
    color: "black",
  },
  imagePickerButton: {
    borderRadius: 5,
    backgroundColor: "#ffc478",
    padding: 5,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 12,
    marginBottom: 10,
    marginTop: 20,
  },
  imagePickerButtonText: {
    color: "white",
    fontSize: 16,
  },
  imageIcon: {
    fontSize: 30,
    marginRight: 5,
  },
  submitButton: {
    backgroundColor: "#ffc478",
    padding: 8,
    marginTop: 30,
    width: "80%",
    alignItems: "center",
    borderRadius: 5,
    marginBottom: 10,
  },
  submitButtonText: {
    fontSize: 24,
    color: "white",
  },
  listTab: {
    backgroundColor: "#ffc478",
    height: 100,
    width: Dimensions.get("window").width*0.8,
    padding: 8,
    marginTop: 20,
    alignItems: "center",
    borderRadius: 5,
  },
  listText: {
    fontSize: 24,
    color: "white",
  },
  featureCard: {
    color: "white",
    width: 50,
    height: 50,
    marginLeft: 10,
    marginRight: 10,
  },
  checkInMessageCardContainer: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    marginTop: 20,
  },
  checkinMessageCard: {
    backgroundColor: "#ffc478",
    padding: 8,
    borderRadius: 10,
    maxWidth: "70%",
  },
  checkinMessageText: {
    fontSize: 20,
    color: "white",
    marginBottom: 5,
  },
  emojiAvatar: {
    width: 40,
    height: 40,
    borderRadius: 10,
    marginLeft: "5%",
    marginRight: "5%",
  },
  checkinDateTime: {
    width: "100%",
    textAlign: "center",
    marginBottom: 5,
    fontSize: 14,
    color: "#686868",
  },
  checkinImage: {
    width: 0.65 * Dimensions.get("window").width,
    height: 0.65 * Dimensions.get("window").width,
    borderRadius: 5,
  },
  contactInfoCard: {
    backgroundColor: "#ffc478",
    height: 110,
    width: Dimensions.get("window").width*0.8,
    padding: 8,
    marginTop: 20,
    alignItems: "center",
    borderRadius: 5,
  },
});

export default styles;
